


















import Vue from 'vue';
import ContactInfoForm from '@/components/deployment/ContactInfoForm.vue';
import ContactInfoUtils, { ContactInfo } from '../../utils/ContactInfoUtils';
import cloneDeep from "lodash.clonedeep";
export default Vue.extend({
  components: {
    ContactInfoForm
  },
  data(): {
    pristine?: Partial<ContactInfo>
    contactInfo?: Partial<ContactInfo>
  } {
    return {
      pristine: undefined,
      contactInfo: undefined,
    };
  },
  async mounted() {
    try {
      this.contactInfo = await ContactInfoUtils.api.get();
    } catch (error) {
      this.$alert.show('mounted', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
  methods: {
    async submit() {
      if (this.contactInfo) {
        try {
          this.$alert.hide('submit');
          await ContactInfoUtils.api.update(this.contactInfo as ContactInfo);
          this.pristine = cloneDeep(this.contactInfo);
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.$languageobj('model.deployment.contactInfo.label')],
            }),
          });
        } catch (error) {
          this.$alert.show('submit', {
            type: 'error',
            messages: this.$handleAPIError(error, this.$refs.observer),
          });
        }
      }
    }
  }
});
